import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationStore = defineStore(
  'navigation',
  () => {
    const groupClosed = ref<string[]>([]);

    function toggleGroup(group: string) {
      if (groupClosed.value.includes(group)) {
        groupClosed.value = groupClosed.value.filter((g) => g !== group);
      } else {
        groupClosed.value.push(group);
      }
    }

    return { groupClosed, toggleGroup };
  },
  {
    // Typescript of pinia is broken, when using persist
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    persist: true
  }
);
